module.exports = __webpack_public_path__ + "img/doctor07.57c68081.jpg";